import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Users } from '@sorare/core/src/atoms/icons/Users';
import { glossary } from '@sorare/core/src/lib/glossary';

import { InviteDialog } from '../InviteDialog';

const StyledButton = styled(Button)`
  border: 1px solid var(--c-set-surface-primary);
`;

export const InviteButton = () => {
  const [inviteDialogOpen, setInviteDialogOpen] = useState(false);

  return (
    <>
      <StyledButton
        size="compact"
        color="quaternary"
        onClick={() => {
          setInviteDialogOpen(true);
        }}
        startIcon={<Users />}
      >
        <FormattedMessage {...glossary.invite} />
      </StyledButton>
      {!!inviteDialogOpen && (
        <InviteDialog
          open
          onClose={() => {
            setInviteDialogOpen(false);
          }}
        />
      )}
    </>
  );
};
